"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedMarkdown = void 0;
var AnimatedMarkdown_1 = require("./components/AnimatedMarkdown");
Object.defineProperty(exports, "AnimatedMarkdown", { enumerable: true, get: function () { return __importDefault(AnimatedMarkdown_1).default; } });
